<!--[elementId]="'checkTimes'"  Todo: ver para que se usa-->
<card-info-detail-v2
  class="content-detail"
  [showButton]="true"
  (viewMoreLessEvent)="onClickViewMoreLess($event)"
>
  <h2 title class="name" i18n="@@cancelpolicies_politicas_y_condiciones">
    Políticas y condiciones
  </h2>
  <span expanded-info>
    <div class="text">
      <p
        i18n="
          @@cancelpolicies_las_condiciones_de_cancelacion_pueden_variar_segun_el_tipo_de_habitacion_consulta_las_distintas_opciones_en_el_detalle_de_cada_habitacion"
      >
        <span
          >Las condiciones de cancelación pueden variar según el tipo de habitación.</span
        >
        <span *ngIf="!viewLess"
          >Consulta las distintas opciones en el detalle de cada habitación.</span
        >
      </p>
      <p
        *ngIf="isUSA && !isDisney && !viewLess"
        i18n="
          @@cancelpolicies_pueden_existir_cargos_adicionales_a_pagar_en_el_alojamiento_que_no_han_sido_proporcionados_por_el_proveedor"
      >
        Pueden existir cargos adicionales a pagar en el alojamiento que no han sido
        proporcionados por el proveedor.
      </p>
      <p
        *ngIf="isUSA && isDisney && !viewLess"
        i18n="
          @@cancelpolicies_pueden_existir_cargos_adicionales_a_pagar_en_el_hotel_que_no_han_sido_proporcionados_por_el_proveedor"
      >
        Pueden existir cargos adicionales a pagar en el hotel que no han sido
        proporcionados por el proveedor.
      </p>
    </div>
  </span>
</card-info-detail-v2>
